if (!customElements.get("ops-cart")) {
	customElements.define(
		"ops-cart",
		class OpsCartItem extends HTMLElement {
			connectedCallback() {
				this.elements = {
					root: this,
				};
			}

			disconnectedCallback() {
				// TODO: reidenzon - Something interesting!
			}
		},
	);
}
